<template>
  <article>
    <div id="BARRING_PIN_PROTECTION" class="container-fixed">
      <header>
        <p class="offset-bottom-2 offset-top-2" v-html="$t('barring.pinProtectionInfotext')"></p>
      </header>
    </div>

    <section>
      <transition name="fade" mode="out-in" appear>
        <VSpinner v-if="isLoading" class="offset-top-2" />
        <section v-else-if="isSuccess" role="status" aria-live="polite">
          <div class="container-fixed">
            <div class="notification notification-dismissible notification-positive">
              <button type="button" class="close" @click="onCloseSuccess">
                <VSvgIcon name="cancel" variant="outlined" />
                <span class="sr-only">{{ $t('common.close') }}</span>
              </button>
              <div class="notification-left">
                <div class="icon-frame">
                  <VSvgIcon name="confirm" variant="outlined" size="large" />
                </div>
              </div>
              <div class="notification-content">
                <div class="notification-heading offset-top-1">
                  {{ $t('barring.noticeSaveSuccessful') }}
                </div>
              </div>
            </div>
          </div>
        </section>
        <div v-else>
          <div v-if="isBlocked && !isBarringPinResetAllowed" class="container-fixed">
            <section class="notification notification-negative">
              <div class="notification-left">
                <div class="icon-frame">
                  <VSvgIcon name="warning" variant="outlined" size="middle" />
                </div>
              </div>
              <div class="notification-content">
                <div class="notification-heading offset-top-1">
                  <span v-html="$t('barring.pinProfileBlockedInfotext')" />
                </div>
              </div>
            </section>
          </div>
          <VTabset v-else grayed>
            <VTab v-if="isBarringPinResetAllowed" label="barring.tabCC" :title="$t('barring.tooltipTabCC')" name="formCC">
              <VForm :form="formCC" @submit="onSubmit">
                <div class="row">
                  <div class="pin-cc col-xl-5 col-l-6 col-m-12 col-s-12">
                    <dl class="status-text list-desc-grid list-desc-semibold">
                      <dt>{{ $t('barring.labelStatus') }}:</dt>
                      <dd>{{ $t(isBlocked ? 'barring.statusIsBlockedTrue' : 'barring.statusIsBlockedFalse') }}</dd>

                      <dt>{{ $t('barring.labelPin') }}:</dt>
                      <dd>{{ $t(hasPin ? 'barring.statusHasPinTrue' : 'barring.statusHasPinFalse') }}</dd>
                    </dl>

                    <p v-html="$t('barring.pinProtectionInfotextCC')"></p>

                    <VInput
                      name="newPin"
                      :label="$t('barring.legendNewPinCC')"
                      :placeholder="$t('barring.placeholderNewPinCC')"
                      autocomplete="off"
                      :title="$t('barring.titleNewPinCC')"
                      :required="false"
                    />

                    <div class="pull-right">
                      <button type="submit" class="btn btn-brand" :disabled="isBusy">
                        {{ $t('barring.btnPinSubmit') }}
                      </button>
                    </div>
                  </div>
                  <ul class="status-images">
                    <li>
                      <img :src="pinProtectImg" alt="" aria-hidden="true" />
                      <h3 v-if="hasPin" class="active-bar">
                        {{ $t('barring.pinActive') }}
                      </h3>
                      <h3 v-else class="inactive-bar">
                        {{ $t('barring.pinNotActive') }}
                      </h3>
                    </li>
                    <li>
                      <img :src="userImg" alt="" aria-hidden="true" />
                      <h3 v-if="isBlocked" class="active-bar">
                        {{ $t('barring.profileLocked') }}
                      </h3>
                      <h3 v-else class="inactive-bar">
                        {{ $t('barring.profileNotLocked') }}
                      </h3>
                    </li>
                  </ul>
                </div>
              </VForm>
            </VTab>
            <VTab
              v-if="!hasPin && !isBarringPinResetAllowed"
              label="barring.tabCreatePin"
              active
              :title="$t('barring.tooltipTabCreatePin')"
              name="formCreatePin"
            >
              <VForm :form="formCreatePin" @submit="onSubmit">
                <div class="row">
                  <div class="col-xl-5 col-l-6 col-m-12">
                    <VInput
                      name="newPin"
                      :label="$t('barring.legendNewPin')"
                      :placeholder="$t('barring.placeholderNewPin')"
                      :title="$t('barring.titleNewPin')"
                      type="password"
                      required
                    />

                    <VInput
                      name="newPinRepeat"
                      :label="$t('barring.legendNewPinRepeat')"
                      :placeholder="$t('barring.placeholderNewPinRepeat')"
                      :title="$t('barring.titleNewPinRepeat')"
                      type="password"
                      required
                    />
                  </div>
                </div>

                <div class="row offset-bottom-4">
                  <div class="col-xl-5 col-l-6 col-m-12">
                    <div class="pull-right offset-top-2 button-bar">
                      <button type="submit" class="btn btn-brand" :disabled="isBusy">
                        {{ $t('barring.btnPinSubmit') }}
                      </button>
                    </div>
                    <p class="clearfix"></p>
                  </div>
                </div>
              </VForm>
            </VTab>
            <VTab
              v-if="hasPin && !isBarringPinResetAllowed"
              label="barring.tabChangePin"
              active
              :title="$t('barring.tooltipTabChangePin')"
              name="formChangePin"
            >
              <VForm :form="formChangePin" @submit="onSubmit">
                <div class="row">
                  <div class="col-xl-5 col-l-6 col-m-12">
                    <VInput
                      name="oldPin"
                      :label="$t('barring.legendOldPin')"
                      :placeholder="$t('barring.placeholderOldPin')"
                      :title="$t('barring.titleOldPin')"
                      type="password"
                      required
                    />

                    <VInput
                      name="newPin"
                      :label="$t('barring.legendNewPin')"
                      :placeholder="$t('barring.placeholderNewPin')"
                      :title="$t('barring.titleNewPin')"
                      type="password"
                      required
                    />

                    <VInput
                      name="newPinRepeat"
                      :label="$t('barring.legendNewPinRepeat')"
                      :placeholder="$t('barring.placeholderNewPinRepeat')"
                      :title="$t('barring.titleNewPinRepeat')"
                      type="password"
                      required
                    />
                  </div>
                </div>

                <div class="row offset-bottom-4">
                  <div class="col-xl-5 col-l-6 col-m-12">
                    <div class="pull-right offset-top-2 button-bar">
                      <button type="submit" class="btn btn-brand" :disabled="isBusy">
                        {{ $t('barring.btnPinSubmit') }}
                      </button>
                    </div>
                    <p class="clearfix"></p>
                  </div>
                </div>
              </VForm>
            </VTab>
            <VTab v-if="hasPin && !isBarringPinResetAllowed" label="barring.tabDeletePin" :title="$t('barring.tooltipTabDeletePin')" name="formDeletePin">
              <VForm :form="formDeletePin" @submit="onSubmit">
                <div class="row">
                  <div class="col-xl-5 col-l-6 col-m-12">
                    <VInput
                      name="oldPin"
                      :label="$t('barring.legendOldPin')"
                      :placeholder="$t('barring.placeholderOldPin')"
                      :title="$t('barring.titleOldPin')"
                      type="password"
                      required
                    />
                  </div>
                </div>

                <div class="row offset-bottom-4">
                  <div class="col-xl-5 col-l-6 col-m-12">
                    <div class="pull-right offset-top-2 button-bar">
                      <button type="submit" class="btn btn-brand" :disabled="isBusy">
                        {{ $t('barring.btnPinSubmit') }}
                      </button>
                    </div>
                    <p class="clearfix"></p>
                  </div>
                </div>
              </VForm>
            </VTab>
          </VTabset>
        </div>
      </transition>
    </section>
  </article>
</template>

<script>
import { mapGetters } from 'vuex';
import Form from '@/components/Form/Form';
import Input from '@/components/Form/Input';
import { focusFirst, hasMinLength, hasMinLengthOrEmpty, initFields, isEqualTo, match, matchOrEmpty } from '@/utils/form';
import { ERROR } from '@route-types';
import TitleMixin from '@/mixins/title';
import Proxy from '@/proxies/BarringProxy';
import VSpinner from '@/components/Spinner';
import focus from '@/directives/focus';
import { sha256 } from 'js-sha256';
import VSvgIcon from '@/components/UI/VSvgIcon.vue';
export const pinMinLength = 4;
export const pinRegExp = /^[A-Za-z0-9]+$/;
export const errorCodeWrongPin = '-20063';
export const defaultValidators = [
  { handler: hasMinLength(pinMinLength), hint: 'barring.errorPinMinLength' },
  { handler: match(pinRegExp), hint: 'barring.errorPinRegExp' },
];

export default {
  name: 'BarringProfilePinprotection',

  directives: {
    focus,
  },

  components: {
    VSvgIcon,
    VSpinner,
    VForm: Form,
    VInput: Input,
    VTabset: () => import('@/components/UI/Tabs/Tabset'),
    VTab: () => import('@/components/UI/Tabs/Tab'),
  },

  mixins: [TitleMixin],

  data() {
    const formCC = initFields({
      name: 'newPin',
      validators: [
        { handler: hasMinLengthOrEmpty(pinMinLength), hint: 'barring.errorPinMinLength' },
        { handler: matchOrEmpty(pinRegExp), hint: 'barring.errorPinRegExp' },
      ],
    });

    const formCreatePin = initFields(
      {
        name: 'newPin',
        validators: defaultValidators,
      },
      {
        name: 'newPinRepeat',
        validators: [{ handler: isEqualTo('newPin'), hint: 'barring.errorPinNotMatch' }],
      }
    );

    const formChangePin = initFields(
      {
        name: 'oldPin',
        validators: defaultValidators,
      },
      {
        name: 'newPin',
        validators: defaultValidators,
      },
      {
        name: 'newPinRepeat',
        validators: [{ handler: isEqualTo('newPin'), hint: 'barring.errorPinNotMatch' }],
      }
    );

    const formDeletePin = initFields({
      name: 'oldPin',
      validators: defaultValidators,
    });

    return {
      isLoading: true,
      isSuccess: false,
      isBusy: false,
      hasPin: null,
      isBlocked: null,
      formCC,
      formCreatePin,
      formChangePin,
      formDeletePin,
    };
  },

  computed: {
    ...mapGetters('system', ['isBarringPinResetAllowed']),

    pinProtectImg() {
      return require(`@/assets/images/barring/pinprotection/pin-protect-` + (this.hasPin ? 'aktiv' : 'inaktiv') + `.svg`);
    },

    userImg() {
      return require(`@/assets/images/barring/pinprotection/blocked-user-` + (this.isBlocked ? 'aktiv' : 'inaktiv') + `.svg`);
    },
  },

  async created() {
    await this.init();
    if (this.isBlocked) {
      this.$webtrekk.viewPage('pinschutzprofilgesperrt', 'authentication.common');
    } else {
      this.$webtrekk.viewPage('pinschutzkundensicht', 'authentication.common');
    }
  },

  methods: {
    async init() {
      this.isLoading = true;
      const response = await new Proxy().getProfileStatus();
      this.hasPin = response.hasPin;
      this.isBlocked = response.isBlocked;
      this.isLoading = false;
    },

    async onSubmit({ form, values, isValid }) {
      if (!isValid) return;
      try {
        this.isBusy = true;
        Object.keys(values).forEach((key) => {
          if (values[key]) values[key] = sha256(values[key]);
        });
        await new Proxy().setPin(values);
        this.isSuccess = true;
        this.isBusy = false;
      } catch (error) {
        if (form.oldPin && error?.data?.message === errorCodeWrongPin) {
          form.oldPin.setInvalid('barring.errorInvalidPin');
          focusFirst(form);
          this.isBusy = false;
        } else {
          this.$router.push({ name: ERROR, params: { error } });
        }
      }
    },

    onCloseSuccess() {
      this.isSuccess = false;
      this.init();
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@scss';

.status-images {
  display: inline-block;
  padding: 0;
  margin: 0 12px;

  li {
    display: inline-block;
    width: 190px;
    padding: 24px;
    background-color: #fff;

    &:first-child {
      margin-right: 12px;
    }

    img {
      margin-left: 20px;
    }

    h3 {
      padding: 6px 0 12px;
      margin: 0 0 -10px;
      font-size: 18px;
      font-weight: normal;
      color: #262626;
      text-align: center;
    }

    .active-bar {
      border-bottom: 5px solid black;
    }

    .inactive-bar {
      border-bottom: 5px solid #a4a4a4;
    }
  }
}

.pin-cc {
  margin-bottom: 24px;
}

dl.list-desc-grid {
  display: flex;
  flex-wrap: wrap;
}

.list-desc-grid dt {
  width: 70px;
  text-align: left;
}

.list-desc-grid dd {
  width: calc(100% - 98px);
  margin-left: 12px;
}

@media screen and (max-width: 433px) {
  .status-images {
    display: none;
  }
}

@media screen and (min-width: 434px) {
  .status-text.list-desc-grid {
    display: none;
  }
}
</style>
